module.exports = __webpack_public_path__ + "assets/logo-default-transp.e1ceaba.png";